export default __webpack_public_path__ + "static/media/Kipl.caf82406.png";